import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface SyncParentTagsResponse {
  tags: Array<Tag>;
}

export interface Tag {
  _id: string;
  fieldName: string;
}

export interface SyncParentTagsParams {
  parentId: string;
}

export const syncParentTagsAPI = async ({ parentId }: SyncParentTagsParams) => {
  const resp = await baseAPI.post<SyncParentTagsResponse>(
    `/parents/${parentId}/sync-tags`,
  );
  return resp.data;
};

export const useSyncParentTagsMutation = () => {
  return useMutation({
    mutationFn: async (params: SyncParentTagsParams) => {
      const response = await syncParentTagsAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_TAGS, params.parentId],
      });
    },
  });
};
